import { mergeAttributes } from '@tiptap/core';
import Mention, { MentionOptions } from '@tiptap/extension-mention';
import { capitalizeAndKeepTheRest } from 'helpers/helpers';
import { translateBlock } from 'i18n';

type ExtendedMentionOptions = {
    onFieldClick: (id: string) => void;
    renderURL: (id: string) => string;
};

export default Mention.extend<MentionOptions & ExtendedMentionOptions>({
    name: 'fieldMention',
    addOptions() {
        return {
            ...this.parent?.(),
            onFieldClick: (_id: string) => {},
            renderURL: (_id: string) => '',
            renderHTML({ options, node }) {
                return [
                    'span',
                    mergeAttributes(
                        { 'data-type': 'fieldMention' },
                        options.HTMLAttributes,
                    ),
                    capitalizeAndKeepTheRest(translateBlock(node.attrs.id)),
                ];
            },
            renderText({ node }) {
                return capitalizeAndKeepTheRest(translateBlock(node.attrs.id));
            },
        };
    },
    addNodeView() {
        return ({ node }) => {
            const anchor = document.createElement('a');
            anchor.classList.add('field-mention');
            anchor.setAttribute('data-type', 'fieldMention');
            anchor.setAttribute('data-id', node.attrs.id);
            anchor.setAttribute('contenteditable', 'false');
            anchor.style.cursor = 'pointer';
            anchor.style.textDecoration = 'none';
            anchor.href = this.options.renderURL(node.attrs.id);
            anchor.textContent = capitalizeAndKeepTheRest(
                translateBlock(node.attrs.id),
            );
            const handleClick = (e: MouseEvent) => {
                const isPrimaryClickWithoutModifier =
                    !e.metaKey && !e.ctrlKey && !e.shiftKey && e.button === 0;

                if (isPrimaryClickWithoutModifier) {
                    e.preventDefault();
                    this.options.onFieldClick(node.attrs.id);
                }
            };
            anchor.addEventListener('click', handleClick);
            return {
                dom: anchor,
                destroy() {
                    anchor.removeEventListener('click', handleClick);
                },
            };
        };
    },
});
